import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useAtom } from 'jotai';
import { Section } from '@fiverr-private/fit';
import { useBreakpoints } from '@fiverr-private/business_blocks';
import { useMonitoring } from '../../utils/monitoring';
import { Modal } from '../Modal';
import { LearnMoreProps } from './types';
import classes from './index.module.scss';
import { learnMoreModalOpenedAtom } from './atoms';

const LearnMoreModal = ({ content, triggerChildren }: LearnMoreProps) => {
    const { fireEvents, Providers } = useMonitoring();
    const [, setLearnMoreModalOpened] = useAtom(learnMoreModalOpenedAtom);
    const { isMD } = useBreakpoints();

    const setIsShowLearnModal = useCallback(
        (opened: boolean) => {
            setLearnMoreModalOpened(opened);
        },
        [setLearnMoreModalOpened]
    );

    const onModalOpenBI = useCallback(() => {
        fireEvents({
            [Providers.BigQuery]: {
                type: 'seller_page_about_seller_modal_is_shown',
            },
            [Providers.Mixpanel]: {
                type: 'seller page - view about modal',
            },
        });
    }, [Providers.Mixpanel, fireEvents, Providers.BigQuery]);

    const onModalCloseBI = useCallback(() => {
        fireEvents({
            [Providers.Mixpanel]: {
                type: 'seller page - close about modal',
            },
        });
    }, [Providers.Mixpanel, fireEvents]);

    const onOpen = useCallback(
        (open) => () => {
            setIsShowLearnModal(true);
            onModalOpenBI();
            return open();
        },
        [onModalOpenBI, setIsShowLearnModal]
    );

    const onClose = useCallback(() => {
        onModalCloseBI();
        setIsShowLearnModal(false);
    }, [setIsShowLearnModal, onModalCloseBI]);

    return (
        <Modal
            overlayClassName={classnames(classes.modalOverlay, 'learn-more-modal')}
            trigger={({ open }) => React.cloneElement(triggerChildren, { onClick: onOpen(open) })}
            onClose={onClose}
        >
            {({ close }) => <Section> {React.cloneElement(content, { close })} </Section>}
            {!isMD && <div className={classes.mobileContact} />}
        </Modal>
    );
};

export default LearnMoreModal;
